import { config, errors } from '@yola/ws-sdk';
import httpClient from '@yola/http-client';

const fetchConfig = () => async (dispatch) => {
  try {
    const response = await httpClient.get('/config.json');
    dispatch(config.actions.setServiceConfig(response.data));
  } catch (error) {
    errors.operations.catchError(error);
  }
};

export default fetchConfig;
